import {
  getFirestore,
  doc,
  setDoc,
  getDoc,
  updateDoc,
  serverTimestamp,
  runTransaction,
  GeoPoint
} from 'firebase/firestore'

export const validateRole = (role: string): role is 'member' | 'admin' => {
  return role === 'member' || role === 'admin'
}

export const createUserDocument = async (
  uid: string,
  email: string,
  displayName: string
) => {
  const db = getFirestore()
  const userRef = doc(db, 'users', uid)

  await setDoc(userRef, {
    displayName,
    email,
    handle: null,
    suburb: null,
    location: null,
    role: 'member',
    guidedDiveFlag: false,
    profileComplete: false,
    creditBalance: 0,
    accreditation: null,
    bankDetails: null,
    allowlist: null,
    ratingAggregates: null,
    accountStatus: 'active',
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp()
  })
}

export const updateProfile = async (
  uid: string,
  data: {
    handle: string
    suburb: string
    location: GeoPoint
    guidedDiveFlag: boolean
  }
) => {
  const db = getFirestore()
  const userRef = doc(db, 'users', uid)

  await updateDoc(userRef, {
    handle: data.handle,
    suburb: data.suburb,
    location: data.location,
    guidedDiveFlag: data.guidedDiveFlag,
    profileComplete: true,
    updatedAt: serverTimestamp()
  })
}

export const checkHandleAvailability = async (
  handle: string
): Promise<boolean> => {
  const db = getFirestore()
  const handleRef = doc(db, 'handles', handle)
  const handleDoc = await getDoc(handleRef)

  return !handleDoc.exists()
}

export const updateGuidedDiveFlag = async (
  uid: string,
  guidedDiveFlag: boolean
) => {
  const db = getFirestore()
  const userRef = doc(db, 'users', uid)
  await updateDoc(userRef, { guidedDiveFlag, updatedAt: serverTimestamp() })
}

export const claimHandle = async (uid: string, handle: string) => {
  const db = getFirestore()

  await runTransaction(db, async transaction => {
    const handleRef = doc(db, 'handles', handle)
    const handleDoc = await transaction.get(handleRef)

    if (handleDoc.exists()) {
      throw new Error('Handle is already taken')
    }

    const userRef = doc(db, 'users', uid)

    transaction.set(handleRef, { uid })
    transaction.update(userRef, { handle })
  })
}
